// src/hooks/useBattleTop.js
import { useEffect, useState } from "react";
import { getTopBattleByGender } from "../api/battleApi"; // 경로 OK

// 백엔드에서 내려오는 데이터를 화면에서 쓰기 좋게 정규화
function normalizeRankers(list = []) {
  return list.map((item, index) => ({
    // 순위는 프론트에서 1,2,3... 계산
    rank: index + 1,

    // 백엔드에서 내려보내는 필드 기준 (이름만 맞춰주면 됨)
    userId: item.userId,
    nickname: item.nickname,
    level: item.level,          // 실제 레벨값
    winCount: item.winCount,    // 승리 횟수
    avatarUrl: item.avatarUrl,  // 아바타 이미지 URL (null이면 빈칸 처리)
  }));
}

export function useBattleTop() {
  const [maleRankers, setMaleRankers] = useState([]);
  const [femaleRankers, setFemaleRankers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        // 남자 / 여자 TOP10 한 번에 호출
        const [male, female] = await Promise.all([
          getTopBattleByGender(0), // 남자
          getTopBattleByGender(1), // 여자
        ]);

        if (!cancelled) {
          setMaleRankers(normalizeRankers(male || []));
          setFemaleRankers(normalizeRankers(female || []));
        }
      } catch (err) {
        if (!cancelled) {
          console.error("❌ useBattleTop error", err);
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { maleRankers, femaleRankers, loading, error };
}
